import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MaintenanceWindowFormDataProviderFactory } from '../factory/MaintenanceWindowFormDataProviderFactory';
import { MaintenanceWindowFormBaseDataProvider } from '../dataProvider/MaintenanceWindowFormBaseDataProvider';
import { MaintenanceWindowData, MaintenanceWindowTypeData } from '../types';

export class MaintenanceWindowFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MaintenanceWindowFormDataProviderFactory;
  public dataProvider: MaintenanceWindowFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MaintenanceWindowFormDataProviderFactory(),
    });
  }

  public async getMaintenanceWindow(maintenanceWindowId: string): Promise<MaintenanceWindowData> {
    return this.dataProvider.getMaintenanceWindow(maintenanceWindowId);
  }

  public async getMaintenanceWindowsTypes(): Promise<MaintenanceWindowTypeData[]> {
    return this.dataProvider.getMaintenanceWindowsTypes();
  }

  public async getSuggestedNewMaintenanceWindowName(type: number): Promise<string> {
    return this.dataProvider.getSuggestedNewMaintenanceWindowName(type);
  }

  public async createMaintenanceWindow(record: Object): Promise<Object | null> {
    return this.dataProvider.createMaintenanceWindow(record);
  }

  public async updateMaintenanceWindow(record: Object): Promise<Object | null> {
    return this.dataProvider.updateMaintenanceWindow(record);
  }
}
